import React from "react";

// Rendu SVG des vrais panneaux de signalisation européens (Convention de Vienne).
export default function RoadSign({ type, value, country, size = 96 }) {
  const motorwayColor = country === "FR" ? "#1D4E89" : "#2D6A4F";
  const s = size;
  const wrap = (children, vb = "0 0 100 100") => (
    <svg width={s} height={s} viewBox={vb} xmlns="http://www.w3.org/2000/svg" role="img">
      {children}
    </svg>
  );
  const triangle = (inner) => wrap(<>
    <polygon points="50,5 97,88 3,88" fill="#fff" stroke="#C1121F" strokeWidth="7" strokeLinejoin="round" />
    {inner}
  </>);
  const blueSquare = (inner) => wrap(<>
    <rect x="6" y="6" width="88" height="88" rx="8" fill="#1D4E89" />
    {inner}
  </>);

  switch (type) {
    case "speed-limit":
      return wrap(<>
        <circle cx="50" cy="50" r="48" fill="#fff" stroke="#D62828" strokeWidth="9" />
        <text x="50" y="50" textAnchor="middle" dominantBaseline="central"
              fontFamily="Arial, sans-serif" fontWeight="700"
              fontSize={value && value.length > 2 ? 34 : 40} fill="#1a1a1a">{value}</text>
      </>);
    case "end-speed":
      return wrap(<>
        <circle cx="50" cy="50" r="48" fill="#fff" stroke="#8a8a8a" strokeWidth="6" />
        <line x1="18" y1="80" x2="82" y2="20" stroke="#4a4a4a" strokeWidth="6" />
        <text x="50" y="50" textAnchor="middle" dominantBaseline="central"
              fontFamily="Arial" fontWeight="700" fontSize="38" fill="#4a4a4a">{value}</text>
      </>);
    case "stop":
      return wrap(<>
        <polygon points="30,4 70,4 96,30 96,70 70,96 30,96 4,70 4,30"
                 fill="#C1121F" stroke="#fff" strokeWidth="4" />
        <text x="50" y="52" textAnchor="middle" dominantBaseline="central"
              fontFamily="Arial" fontWeight="800" fontSize="26" fill="#fff">STOP</text>
      </>);
    case "yield":
      return wrap(<>
        <polygon points="4,10 96,10 50,94" fill="#fff" stroke="#C1121F" strokeWidth="9" strokeLinejoin="round" />
      </>);
    case "priority-road":
      return wrap(<>
        <rect x="16" y="16" width="68" height="68" transform="rotate(45 50 50)" fill="#fff" />
        <rect x="21" y="21" width="58" height="58" transform="rotate(45 50 50)" fill="#F4C20D" />
      </>);
    case "end-priority":
      return wrap(<>
        <rect x="16" y="16" width="68" height="68" transform="rotate(45 50 50)" fill="#fff" />
        <rect x="21" y="21" width="58" height="58" transform="rotate(45 50 50)" fill="#F4C20D" />
        <line x1="26" y1="74" x2="74" y2="26" stroke="#4a4a4a" strokeWidth="6" />
      </>);
    case "no-entry":
      return wrap(<>
        <circle cx="50" cy="50" r="48" fill="#C1121F" stroke="#fff" strokeWidth="3" />
        <rect x="20" y="42" width="60" height="16" fill="#fff" />
      </>);
    case "no-overtaking":
      return wrap(<>
        <circle cx="50" cy="50" r="48" fill="#fff" stroke="#C1121F" strokeWidth="8" />
        <rect x="20" y="42" width="26" height="18" rx="3" fill="#C1121F" />
        <rect x="54" y="42" width="26" height="18" rx="3" fill="#2b2b2b" />
      </>);
    case "roundabout":
      return wrap(<>
        <circle cx="50" cy="50" r="48" fill="#1D4E89" />
        <g stroke="#fff" strokeWidth="6" fill="#fff">
          {[0, 120, 240].map((r) => (
            <g key={r} transform={`rotate(${r} 50 50)`}>
              <path d="M31 46 A 24 24 0 0 1 55 29" fill="none" strokeLinecap="round" />
              <polygon points="57,22 66,32 51,35" stroke="none" />
            </g>
          ))}
        </g>
      </>);
    case "motorway":
      return wrap(<>
        <rect x="4" y="8" width="92" height="84" rx="8" fill={motorwayColor} />
        <path d="M32 86 L44 42 L56 42 L68 86 Z" fill="#fff" />
        <rect x="48.5" y="46" width="3" height="7" fill={motorwayColor} />
        <rect x="48" y="59" width="4" height="8" fill={motorwayColor} />
        <rect x="46.5" y="73" width="7" height="9" fill={motorwayColor} />
        <rect x="34" y="22" width="32" height="7" rx="1" fill="#fff" />
        <rect x="36.5" y="29" width="5" height="12" fill="#fff" />
        <rect x="58.5" y="29" width="5" height="12" fill="#fff" />
      </>);
    case "expressway":
      return blueSquare(<>
        <rect x="40" y="30" width="20" height="16" fill="#fff" />
        <polygon points="50,20 34,34 66,34" fill="#fff" />
        <rect x="44" y="46" width="12" height="30" fill="#fff" />
      </>);
    case "one-way":
      return wrap(<>
        <rect x="4" y="30" width="92" height="40" rx="5" fill="#1D4E89" />
        <polygon points="18,50 60,50 60,40 84,50 60,60 60,50" fill="#fff" />
      </>);
    case "children":
      return triangle(<>
        <circle cx="40" cy="46" r="6" fill="#1a1a1a" />
        <path d="M40 52 L40 70 M40 58 L32 66 M40 58 L48 64 M40 70 L34 84 M40 70 L46 84"
              stroke="#1a1a1a" strokeWidth="3.5" fill="none" strokeLinecap="round" />
        <circle cx="62" cy="50" r="6" fill="#1a1a1a" />
        <path d="M62 56 L62 72 M62 60 L55 66 M62 60 L69 66 M62 72 L57 84 M62 72 L67 84"
              stroke="#1a1a1a" strokeWidth="3.5" fill="none" strokeLinecap="round" />
      </>);
    case "danger":
      return triangle(<>
        <rect x="46" y="34" width="8" height="30" rx="3" fill="#1a1a1a" />
        <circle cx="50" cy="76" r="5" fill="#1a1a1a" />
      </>);
    case "animals":
      return triangle(<>
        <path d="M36 78 L36 60 Q36 50 46 50 L58 50 Q66 50 66 44 L66 34 L70 30 L68 40 Q68 56 58 56 L48 56 Q42 56 42 62 L42 78 Z" fill="#1a1a1a" />
        <path d="M66 34 L60 26 M70 30 L74 24" stroke="#1a1a1a" strokeWidth="3" strokeLinecap="round" />
        <rect x="36" y="70" width="4" height="10" fill="#1a1a1a" /><rect x="58" y="70" width="4" height="10" fill="#1a1a1a" />
      </>);
    case "slippery":
      return triangle(<>
        <rect x="34" y="42" width="32" height="16" rx="4" fill="#1a1a1a" />
        <circle cx="42" cy="60" r="4" fill="#1a1a1a" /><circle cx="58" cy="60" r="4" fill="#1a1a1a" />
        <path d="M28 78 Q36 70 32 64 M72 78 Q64 70 68 64" stroke="#1a1a1a" strokeWidth="3.5" fill="none" strokeLinecap="round" />
      </>);
    case "traffic-light":
      return triangle(<>
        <rect x="42" y="30" width="16" height="42" rx="4" fill="#1a1a1a" />
        <circle cx="50" cy="39" r="4.5" fill="#D62828" /><circle cx="50" cy="51" r="4.5" fill="#F4C20D" /><circle cx="50" cy="63" r="4.5" fill="#2D6A4F" />
      </>);
    case "vignette":
      return wrap(<>
        <rect x="8" y="20" width="84" height="60" rx="6" fill="#2D6A4F" stroke="#fff" strokeWidth="3" />
        <text x="50" y="38" textAnchor="middle" fontFamily="Arial" fontWeight="800" fontSize="13" fill="#fff">VIGNETTE</text>
        <rect x="20" y="46" width="60" height="10" fill="#fff" opacity="0.85" />
        <text x="50" y="70" textAnchor="middle" fontFamily="Arial" fontWeight="700" fontSize="11" fill="#fff">AUTOBAHN · CH</text>
      </>);
    case "ztl":
      return wrap(<>
        <circle cx="50" cy="50" r="48" fill="#fff" stroke="#C1121F" strokeWidth="9" />
        <text x="50" y="50" textAnchor="middle" dominantBaseline="central"
              fontFamily="Arial" fontWeight="800" fontSize="26" fill="#1D4E89">ZTL</text>
      </>);
    case "parking":
      return blueSquare(<text x="50" y="52" textAnchor="middle" dominantBaseline="central" fontFamily="Arial" fontWeight="800" fontSize="54" fill="#fff">P</text>);
    case "no-parking":
      return wrap(<>
        <circle cx="50" cy="50" r="48" fill="#1D4E89" stroke="#C1121F" strokeWidth="9" />
        <text x="50" y="52" textAnchor="middle" dominantBaseline="central" fontFamily="Arial" fontWeight="800" fontSize="42" fill="#fff">P</text>
        <line x1="20" y1="80" x2="80" y2="20" stroke="#C1121F" strokeWidth="8" />
      </>);
    case "no-stopping":
      return wrap(<>
        <circle cx="50" cy="50" r="48" fill="#1D4E89" stroke="#C1121F" strokeWidth="9" />
        <line x1="22" y1="78" x2="78" y2="22" stroke="#C1121F" strokeWidth="8" />
        <line x1="22" y1="22" x2="78" y2="78" stroke="#C1121F" strokeWidth="8" />
      </>);
    case "pedestrian-crossing":
      return blueSquare(<>
        <polygon points="50,22 76,72 24,72" fill="#fff" />
        <circle cx="50" cy="38" r="5" fill="#1a1a1a" />
        <path d="M50 43 L50 60 M50 48 L42 55 M50 48 L58 55 M50 60 L44 70 M50 60 L56 70" stroke="#1a1a1a" strokeWidth="3.5" fill="none" strokeLinecap="round" />
      </>);
    case "tunnel":
      return blueSquare(<>
        <path d="M28 74 L28 52 Q28 28 50 28 Q72 28 72 52 L72 74 Z" fill="#fff" />
        <path d="M40 74 L40 58 Q40 46 50 46 Q60 46 60 58 L60 74 Z" fill="#1D4E89" />
      </>);
    case "dead-end":
      return blueSquare(<>
        <rect x="46" y="40" width="8" height="36" fill="#fff" />
        <rect x="30" y="30" width="40" height="10" fill="#C1121F" />
      </>);
    case "snow-chains":
      return wrap(<>
        <circle cx="50" cy="50" r="48" fill="#1D4E89" />
        <circle cx="50" cy="50" r="26" fill="none" stroke="#fff" strokeWidth="7" />
        <circle cx="50" cy="50" r="12" fill="none" stroke="#fff" strokeWidth="5" />
        <g stroke="#fff" strokeWidth="3">
          {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
            <line key={a} x1="50" y1="24" x2="50" y2="30" transform={`rotate(${a} 50 50)`} />
          ))}
        </g>
      </>);
    case "toll":
      return blueSquare(<>
        <rect x="24" y="40" width="52" height="30" fill="#fff" />
        <rect x="30" y="26" width="12" height="16" fill="#fff" />
        <rect x="34" y="30" width="4" height="8" fill="#1D4E89" />
        <rect x="30" y="52" width="40" height="4" fill="#1D4E89" />
      </>);
    default:
      return wrap(<>
        <circle cx="50" cy="50" r="48" fill="#fff" stroke="#8C857B" strokeWidth="6" />
        <text x="50" y="50" textAnchor="middle" dominantBaseline="central" fontSize="30" fill="#8C857B">?</text>
      </>);
  }
}
